const PathParamMetadataKey = Symbol('PATH_PARAM_METADATA_KEY');
const HeaderParamMetadataKey = Symbol('HEADER_PARAM_METADATA_KEY');
const QueryParamMetadataKey = Symbol('QUERY_PARAM_METADATA_KEY');
const BodyMetadataKey = Symbol('BODY_METADATA_KEY');
const BaseUrlParamMetadataKey = Symbol('BASE_URL_METADATA_KEY');
const UploadProgressMetadataKey = Symbol('UPLOAD_PROGRESS_CALLBACK_METADATA_KEY');
const DownloadProgressMetadataKey = Symbol('DOWNLOAD_PROGRESS_CALLBACK_METADATA_KEY');

export {
  PathParamMetadataKey,
  HeaderParamMetadataKey,
  BodyMetadataKey,
  BaseUrlParamMetadataKey,
  QueryParamMetadataKey,
  UploadProgressMetadataKey,
  DownloadProgressMetadataKey
};
